import "../../App.css";

function Experience() {
  return (
    <div className="contentContainer">
      <div className="contentHeader">WORK EXPERIENCE</div>
      <div className="contentBody">
        🌟 See full resume <a href={require("./Amy Chen CV.pdf")}>here</a>!
      </div>
      <div className="contentBody">
        <u>
          <b>Peloton Technologies</b>
        </u>
      </div>
      <div className="contentBody">
        <img
          src={require("../../images/peloton_logo.png")}
          alt="Peloton logo"
          className="companyLogo"
        />
        Software Developer
      </div>
      <div className="contentDescription">
        Sept 2023 - Dec 2023 (Co-op)
        <br />
        Jan 2024 - Current (Full-time)
      </div>
      <div className="contentBody">
        <ul>
          <li style={{ fontWeight: "bold" }}>
            Tech: ASP.NET Core 8 & Framework 4.8, Teleriik Kendo UI, Entity
            Framework Core, Typescript, PHP
          </li>
          <li>
            Led development of a{" "}
            <a href="https://peloton-technologies.com/fintech-peloton-technologies-launches-self-serve-currency-exchange/">
              self-serve Currency Exchange feature
            </a>
            , including Figma UI design mockups, stakeholder consultations, and
            final implementation in .NET and TypeScript. Integrated with the RBC
            Currency Exchange API and identified critical risk factors to ensure
            robust delivery.
          </li>
          <li>
            Automated sales commission ingestion by designing and implementing a
            .NET Entity Framework Core solution to import Excel templates into
            SQL. Ensured data integrity and seamless deployment for leadership
            reporting. Incorporated stakeholder feedback through strong
            communication and continuous iteration.
          </li>
          <li>
            Developed a modern WooCommerce PHP plugin integrating internal APIs
            and webhooks, accompanied by a detailed installation guide that
            secured a key client contract.
          </li>
          <li>
            Implemented automated email payment reminders with customizable
            templates. Collaborated with Marketing and Sales to refine messaging
            and enhance usability.
          </li>
          <li>
            Contributed to major migration of flagship production application
            from .NET Framework 4.8 to .NET 8.0, ensuring a seamless transition.
          </li>
          <li>
            Proactively conducting code reviews and providing feedback while
            applying critical analysis and thorough testing.
          </li>
          <li>
            Facilitated weekly triage of all bugs, assessing impact and urgency
            to inform sprint planning and flag showstoppers.
          </li>
          <li>
            Authored developer logs to improve clarity and cross-team
            transparency regarding new features and bug fixes.
          </li>
        </ul>
      </div>
      <div className="contentBody">
        <u>
          <b>Article</b>
        </u>
      </div>
      <div className="contentBody">
        <img
          src={require("../../images/article_logo.png")}
          alt="Article logo"
          className="companyLogo"
        />
        Full Stack Software Engineer (Co-op)
      </div>
      <div className="contentDescription">May 2022 - Aug 2022</div>
      <div className="contentBody">
        <ul>
          <li style={{ fontWeight: "bold" }}>
            Tech: Java Spring, Vue, Kafka, SQL{" "}
          </li>
          <li>
            Investigated production issues reported by internal teams and
            resolved bugs by auditing AWS CloudWatch logs and the production
            database, improving Java Spring backend stability.
          </li>
          <li>
            Designed JUnit and Mockito tests to increase backend logic coverage
            and ensure reliability through automation.
          </li>
          <li>
            Modified API endpoints and Kafka topics to enhance event-driven
            microservice communication; updated Vue frontend to reflect changes
            and improve visibility.
          </li>
          <li>
            Tested API behavior using Postman and queried the production SQL
            database to audit data integrity and flow.
          </li>
          <li>
            Documented internal architecture, microservices, and M1 chip
            development setup challenges to support onboarding and cross-team
            alignment.
          </li>
        </ul>
      </div>
      <div className="contentBody">
        <u>
          <b>Royal Bank of Canada (RBC)</b>
        </u>
      </div>
      <div className="contentBody">
        <img
          src={require("../../images/rbc_logo.png")}
          alt="RBC logo"
          className="companyLogo"
        />
      </div>
      <div className="contentBody">Software Developer (Co-op)</div>
      <div className="contentDescription">Sept 2021 - Apr 2022</div>
      <div className="contentBody">
        <ul>
          <li style={{ fontWeight: "bold" }}>
            Tech: React, Electron, Node, Java, Powershell, C#, SQLite{" "}
          </li>
          <li>
            Developed a multi-folder Cloud Backup feature with a
            progress-loading bar, and a browser cache deletion tool using
            PowerShell scripting with a React frontend.
          </li>
          <li>
            Delivered features and bug fixes on Windows (Java, C#, PowerShell)
            and ported core functionality to a new web application (React,
            Node.js, Electron).
          </li>
          <li>
            Integrated SQLite into a Java desktop application to centralize app
            usage analytics and improve data collection.
          </li>
          <li>
            Promoted maintainable code practices by consolidating redundant CSS
            and removing hardcoded translations for improved scalability.
          </li>
        </ul>
      </div>
      <div className="contentBody">
        <u>
          <b>Hootsuite</b>
        </u>
      </div>
      <div className="contentBody">
        <img
          src={require("../../images/hootsuite_logo.png")}
          alt="Hootsuite logo"
          className="companyLogo"
        />
      </div>
      <div className="contentBody">Accounts Payable Specialist</div>
      <div className="contentDescription">Feb 2019 - Aug 2020</div>
      <div className="contentBody">
        <ul>
          <li>
            Automated the corporate credit card reconciliation process for 30
            cards, reducing task time significantly through GSheet scripting and
            formulas, and reduced risk of human error
          </li>
          <li>
            Setup a Netsuite script to send remittance emails to our vendors,
            strengthening vendor-customer relations and creating a more robust
            Accounts Payable function
          </li>
          <li>
            Customized macros in Zendesk to standardize communication,
            increasing processing efficiency
          </li>
          <li>
            Established an internal website and created process documentation,
            delivered training to management and peers
          </li>
        </ul>
      </div>
      <hr />
      <div className="contentHeader">VOLUNTEER EXPERIENCE</div>
      <div className="contentBody">
        <u>
          <b>Bachelor of Computer Science Student Association</b>
        </u>
      </div>
      <div className="contentBody">
        <img
          src={require("../../images/bcssa_logo.png")}
          alt="BCSSA logo"
          className="companyLogo"
        />
      </div>
      <div className="contentBody">Treasurer</div>
      <div className="contentDescription">Jan 2021 - Dec 2021</div>
      <div className="contentBody">
        <ul>
          <li>
            Organized the 2021 virtual BCS Hackathon with over 60 participants,
            and secured over $7,000 in funding through grant and sponsorship
            funding{" "}
          </li>
          <li>
            Set up the Hackathon Notion site, finalized schedule, and managed
            all socials for the Hackathon event (Facebook, Devpost, mass emails
            through sendinblue)
          </li>
        </ul>
      </div>
      <div className="contentBody">
        <u>
          <b>
            University of Victoria - Community Volunteer Income Tax Program
            (CRA)
          </b>
        </u>
      </div>
      <div className="contentBody">
        <img
          src={require("../../images/cra_logo.png")}
          alt="Canada Revenue Agency logo"
          className="companyLogo"
        />
      </div>
      <div className="contentBody">Director of Marketing (UVic)</div>
      <div className="contentDescription">Jan 2018 - May 2018</div>
      <div className="contentBody">
        <ul>
          <li>
            Designed and executed a scheduled marketing and socials plan to
            increase engagement with the local community out of our clinics
            through the UVic Gustavson School of Business
          </li>
          <li>
            Tailored communication tools to ensure precision and clarity in
            wording, establishing materials to be used in future years,and
            reached out to all potential community organizations and partners
          </li>
          <li>
            Created print and digital advertising content from scratch in Adobe
            Illustrator
          </li>
          <li>
            Accurately prepared T1 tax e-Filing for eligible community members
          </li>
        </ul>
      </div>
      <div className="contentBody">
        <u>
          <b>German Red Cross</b>
        </u>
      </div>
      <div className="contentBody">
        <img
          src={require("../../images/redcross_logo.png")}
          alt="German Red Cross logo"
          className="companyLogo"
        />
      </div>
      <div className="contentBody">Refugee Engagement</div>
      <div className="contentDescription">Oct 2017 - Dec 2017</div>
      <div className="contentBody">
        <ul>
          <li>
            Organized cultural activities in French to expose Guinean refugee
            camp residents to the language and customs of Germany
          </li>
          <li>
            Assisted in running the Christmas potluck at the Benjamin Franklin
            Village Refugee Camp, and running the childrens activity tables
          </li>
        </ul>
      </div>
    </div>
  );
}

export default Experience;
